export default __webpack_public_path__ + "static/media/souled.ecf36902.png";